"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var LeasedOrgsGuard = /** @class */ (function () {
    function LeasedOrgsGuard(router) {
        this.router = router;
    }
    LeasedOrgsGuard.prototype.canActivate = function (route, state) {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser && currentUser.hasLeasedOrgs) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/'], { queryParams: { returnUrl: state.url } });
        return false;
    };
    return LeasedOrgsGuard;
}());
exports.LeasedOrgsGuard = LeasedOrgsGuard;
